module.exports = __webpack_public_path__ + "static/media/SJE-Rhombus-Logo-Vert-2017.de8278ba.jpg";